import { Routes, Route } from 'react-router'
import React, { useState } from 'react'
import { Box, Stack, Theme, useMediaQuery, useTheme } from '@mui/material'
import ErrorBoundary from './shared/components/errorboundary/ErrorBoundary'
import RegistrationIDPContinueScreen from './modules/registration/shared/RegistrationIDPContinueScreen'
import { RegistrationIDPInterstitialPendingKey, RegistrationIDPInterstitialProviderKey } from './shared/Constants'
import { getSessionStorage, removeSessionStorage } from './shared/utilities/Session'
import RcmLoginBackground from './modules/login/shared/components/RcmLoginBackground'
const AccountVerification = React.lazy(() => import('./modules/login/verification/AccountVerification'))

const AppUnverifiedRoutes: React.FC = () => {
  const theme = useTheme<Theme>()
  const isSmallerDevice = useMediaQuery(theme.breakpoints.down('md'))
  const [showIDPInterstitial, setShowIDPInterstitial] = useState(
    () => getSessionStorage(RegistrationIDPInterstitialPendingKey) === 'true'
  )
  const provider = getSessionStorage(RegistrationIDPInterstitialProviderKey) ?? 'Default'

  const handleContinue = () => {
    removeSessionStorage(RegistrationIDPInterstitialPendingKey)
    removeSessionStorage(RegistrationIDPInterstitialProviderKey)
    setShowIDPInterstitial(false)
  }

  return (
    <ErrorBoundary message="Page failed to load, please refresh your browser to try again.">
      <React.Suspense fallback={<></>}>
        {showIDPInterstitial ? (
          <Stack direction="row" sx={{ minHeight: '100vh', '@supports (min-height: 100dvh)': { minHeight: '100dvh' } }}>
            <Box height="auto" flexBasis="50vw" display={isSmallerDevice ? 'none' : 'flex'} flexShrink={0}>
              <RcmLoginBackground />
            </Box>
            <Box
              sx={{ backgroundColor: (theme) => theme.palette.colors?.softwhite }}
              flexBasis={isSmallerDevice ? '100%' : '50%'}
            >
              <Box
                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}
                mt={{ xs: 2, sm: 5, md: 10 }}
                padding={2}
              >
                <RegistrationIDPContinueScreen provider={provider} onContinue={handleContinue} />
              </Box>
            </Box>
          </Stack>
        ) : (
          <Routes>
            <Route path="/register" element={<AccountVerification />} />
            <Route path="*" element={<AccountVerification />} />
          </Routes>
        )}
      </React.Suspense>
    </ErrorBoundary>
  )
}

export { AppUnverifiedRoutes }
